// extracted by mini-css-extract-plugin
export var actions = "styles-module--actions--9b7b7";
export var banner = "styles-module--banner--fdaf0";
export var btn = "styles-module--btn--94541";
export var category = "styles-module--category--76cb0";
export var categoryText = "styles-module--categoryText--46343";
export var categoryTitle = "styles-module--categoryTitle--2aa86";
export var copy = "styles-module--copy--58f91";
export var link = "styles-module--link--b2355";
export var modalActions = "styles-module--modalActions--83ad1";
export var modalIntro = "styles-module--modalIntro--71373";
export var modalTitle = "styles-module--modalTitle--b8e75";
export var primary = "styles-module--primary--accb2";
export var secondary = "styles-module--secondary--9c854";